import React, { useState, useCallback } from "react";
import { createMarkerIcon } from "../../utils/map/mapIcons";
import { HapticFeedback } from "../../utils/hapticFeedback";
import styles from "./AddMarkerButton.module.css";

type MarkerType = "dps" | "clean" | "dtp";

interface AddMarkerButtonProps {
  onSelectType: (type: MarkerType) => void;
  theme: "light" | "dark";
}

export const AddMarkerButton: React.FC<AddMarkerButtonProps> = ({
  onSelectType,
  theme,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = useCallback(() => {
    HapticFeedback.light();
    setIsOpen((prev) => !prev);
  }, []);

  const handleSelectType = useCallback(
    (type: MarkerType) => {
      HapticFeedback.medium();
      onSelectType(type);
      setIsOpen(false);
    },
    [onSelectType]
  );

  return (
    <div className={styles.container}>
      {/* Контейнер с иконками и кнопкой */}
      <div
        className={`${styles.mainContainer} ${isOpen ? styles.open : ""} ${
          theme === "dark" ? styles.dark : ""
        }`}
      >
        {/* Иконки типов меток */}
        <div className={styles.typesContainer}>
          {/* ДПС - первая сверху */}
          <button
            className={styles.typeButton}
            onClick={() => handleSelectType("dps")}
            style={{
              transitionDelay: isOpen ? "0s" : "0.1s",
            }}
          >
            <img
              src={createMarkerIcon("dps", 0, theme)}
              alt="ДПС"
              className={styles.markerIcon}
            />
          </button>

          {/* Чисто - вторая */}
          {/* <button
            className={styles.typeButton}
            onClick={() => handleSelectType("clean")}
            style={{
              transitionDelay: isOpen ? "0.05s" : "0.05s",
            }}
          >
            <img
              src={createMarkerIcon("clean", 0, theme)}
              alt="Чисто"
              className={styles.markerIcon}
            />
          </button> */}

          {/* ДТП - третья */}
          <button
            className={styles.typeButton}
            onClick={() => handleSelectType("dtp")}
            style={{
              transitionDelay: isOpen ? "0.1s" : "0s",
            }}
          >
            <img
              src={createMarkerIcon("dtp", 0, theme)}
              alt="ДТП"
              className={styles.markerIcon}
            />
          </button>
        </div>

        {/* Главная кнопка */}
        <button className={styles.mainButton} onClick={handleToggle}>
          <div className={`${styles.plusIcon} ${isOpen ? styles.rotated : ""}`}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.75 9H17.25M9 0.75V17.25"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </button>
      </div>
    </div>
  );
};
